export default __webpack_public_path__ + "static/media/mic.dbdc68c6.svg";